import { useMutation } from '@tanstack/react-query'
import { submitSupportRequest } from '../api/support.api'
import type { SupportRequestPayload } from '../api/contracts'

export function useSubmitSupportRequest() {
  const mutation = useMutation({
    mutationFn: (payload: SupportRequestPayload) => submitSupportRequest(payload),
  })

  return {
    submit: mutation.mutateAsync,
    isSubmitting: mutation.isPending,
    isSuccess: mutation.isSuccess,
    reset: mutation.reset,
  }
}
